var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M69 82.2h-8.2v-7.7c0-2.2 1.8-3.9 4.1-3.9 2.2 0 4.1 1.8 4.1 3.9v7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M64.9 70.5h36.8c2.2 0 4.1 1.8 4.1 3.9V124.3H69V74.4M74.9 111.6h24.9M74.9 104.2h24.9M74.9 96.7h24.9M74.9 89.3h24.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M115.8 53.8V35.9c0-1.7 1.4-3 3-3h47.3l15.7 14.3V114c0 1.7-1.4 3-3 3h-27.5M181.8 47.2h-15.6M166.2 47.2V32.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M151.3 105.1v34.6H17.9V53.8h133.4v29.5M76.6 141v8.5c-.1 9.9-10.5 9.6-10.5 9.6H41.8v6.4h85.9l-.1-6.4h-24.3s-10.5.4-10.5-9.6V141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M139.8 90.3v7.8H160v9.5l13.4-14.1-13.8-12.9v9.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportDocuments);
export default __webpack_public_path__ + "static/media/exportDocuments.dc51689e3b57ea81c3911ed809466dd1.svg";
export { ForwardRef as ReactComponent };